module.exports = require("./ff-Adlm-GM.d.ts");